import { render, staticRenderFns } from "./workload.vue?vue&type=template&id=1ea2d4ae&scoped=true&"
import script from "./workload.vue?vue&type=script&lang=js&"
export * from "./workload.vue?vue&type=script&lang=js&"
import style0 from "./workload.vue?vue&type=style&index=0&id=1ea2d4ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea2d4ae",
  null
  
)

export default component.exports